import { createGenericSlice } from 'store/generic-rest-api';
import { getRoleDetails, updateRoleDetails } from './actions';

const roleDetailsSlice = createGenericSlice('roleDetailsSlice', {}, {
	itemAction: getRoleDetails,
	updateAction: updateRoleDetails,
});

export const roleDetailsReducer = roleDetailsSlice.reducer;
